import { useCallback, useState } from "react";
import * as service from "../service/tags";
import useTagsStore from "../store/tags";

export const useServicesTags = () => {
  const { tags, setTags, setLoading, loading } = useTagsStore();
  const [error, setError] = useState(null);

  const fetchTags = useCallback(async () => {
    return service.getServicesTags();
  }, []);

  const getTags = useCallback(async () => {
    setLoading(true);
    try {
      const data = await fetchTags();
      setTags(data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [fetchTags, setTags, setLoading]);

  const createTag = useCallback(
    async (serviceName, tags) => {
      await service.createServiceTag(serviceName, tags);
      await getTags();
    },
    [setTags, getTags]
  );

  return { tags, getTags, createTag, loading, error };
};

export const useSearchTags = () => {
  const searchTags = useCallback(async (query) => {
    return service.searchTags(query);
  }, []);

  return { searchTags };
};
